import { Component } from '@angular/core';
import { NotificationDto, NotificationModel, NotificationType } from '@sestek/notification';
import { ToasterService } from '@abp/ng.theme.shared';
import { LocalizationService } from '@abp/ng.core';
import { AiAgentPreparationFailedWarningNotificationModel } from '../models/ai-agent-preparation-failed-warning-notification-model';

@Component({
  selector: 'cai-ai-agent-preparation-failed-warning-notification',
  templateUrl: './ai-agent-preparation-failed-warning-notification.component.html',
  standalone: false,
})
@NotificationType('AiAgentPreparationFailedWarningNotification')
export class AiAgentPreparationFailedWarningNotificationComponent {
  _data: NotificationDto;

  get data() {
    return this._data;
  }
  set data(data: NotificationDto) {
    this._data = data;
    this.notification = JSON.parse(data.payload);
  }

  notification: AiAgentPreparationFailedWarningNotificationModel;

  constructor(
    private localizationService: LocalizationService,
    private toasterService: ToasterService,
  ) {}

  showNotification(notification: NotificationModel) {
    this.notification = JSON.parse(notification.payload);

    const warningMessage = this.localizationService.instant(
      'AiAgent::PreparationFailedWarningMessage',
      this.notification.projectName,
      this.notification.aiAgentNames,
    );

    this.toasterService.warn(warningMessage, null, { sticky: true });
  }
}
